import {
  SET_SOURCEOFFUND,
  GET_ALLOWED_SOURCEOFFUNDS_REQUEST,
  GET_ALLOWED_SOURCEOFFUNDS_SUCCESS,
  GET_ALLOWED_SOURCEOFFUNDS_FAILURE,
  CLEANUP,
} from "./selectSourceOfFundType";

import { getSourceOfFundCode } from "api/api";

export const cleanup = () => {
  return {
    type: CLEANUP,
  };
};

export const setSourceOfFund = (sourceOfFund) => {
  return {
    type: SET_SOURCEOFFUND,
    sourceOfFund: sourceOfFund,
  };
};

const getAllowedSourceOfFundsRequest = () => {
  return {
    type: GET_ALLOWED_SOURCEOFFUNDS_REQUEST,
  };
};

const getAllowedSourceOfFundsSuccess = (payload) => {
  return {
    type: GET_ALLOWED_SOURCEOFFUNDS_SUCCESS,
    payload: payload,
  };
};

const getAllowedSourceOfFundsFailure = (error) => {
  return {
    type: GET_ALLOWED_SOURCEOFFUNDS_FAILURE,
    payload: error,
  };
};

export const getAllowedSourceOfFunds = () => {
  return async (dispatch) => {
    dispatch(getAllowedSourceOfFundsRequest());
    try {
      var response = await getSourceOfFundCode();

      // return data
      dispatch(getAllowedSourceOfFundsSuccess(response));
    } catch (error) {
      dispatch(getAllowedSourceOfFundsFailure(error.message));
    }
  };
};
